export function generationErrorMessage(error: unknown): string {
  const message = error instanceof Error ? error.message : String(error ?? '');
  if (message.includes('Requested entity was not found')) {
    return 'API Key invalid or expired. Please select a key again.';
  }
  return 'AI Generation failed. Please check your connection or try again.';
}

export function renderSaveErrorMessage(error: unknown): string {
  const candidate = error as { status?: number; body?: { error?: string }; message?: string } | null;
  if (candidate?.status === 402) {
    return candidate.body?.error || 'Geen credits meer';
  }
  return candidate?.message || 'Opslaan van render mislukt';
}
